import { useEffect } from "react";
import SupabaseInstance from "@/integrations/supabase/SupabaseInstance";
import useAuth from "./useAuth";

/**
 * Suscribe al usuario a cambios en tiempo real de su fila en la tabla `subscriptions`.
 * Cuando el webhook de Stripe hace upsert, este hook llama refreshUser() para sincronizar
 * el contexto de auth con los metadatos actualizados — sin polling.
 *
 * Requisito: la tabla `subscriptions` debe estar en la publicación de Realtime.
 * SQL: ALTER PUBLICATION supabase_realtime ADD TABLE subscriptions;
 */
export function useSubscriptionSync() {
  const { user, refreshUser } = useAuth();

  useEffect(() => {
    if (!user?.id) return;

    const channel = SupabaseInstance.onChannel(
      `subscription-sync:${user.id}`,
      {
        event: "*",
        schema: "public",
        table: "subscriptions",
        filter: `user_id=eq.${user.id}`,
      },
      async () => {
        // El webhook actualiza `subscriptions` primero y luego llama al admin API
        // para actualizar user_metadata. Un pequeño delay asegura que la metadata
        // esté lista cuando llegue el evento de Realtime.
        await new Promise((resolve) => setTimeout(resolve, 600));
        await refreshUser();
      },
    );

    return () => {
      channel.unsubscribe();
    };
  }, [user?.id, refreshUser]);
}
